export default {
    learnMore: 'SAIBA MAIS',
    unlock: 'Quero ser premium!',

    bar: {
        bannerAlt: 'Guia do ano 2022',
        messagePremium: 'Comece 2022 preparad{pronoun}!',
        message: 'Seja Premium e comece 2022 preparad{pronoun}!'
    },

    intro: {
        cancelAtWill: 'Cancele quando desejar',
    },

    modal: {
        logoAlt: 'Logo Astrolink',
        imageAlt: 'Guia do ano 2022',
        messagePremium: 'Acesse previsões de Astrologia, Tarot, artigos e atividades para você começar o ano preparad{pronoun}!',
        message: 'Seja premium por <strong>apenas {currency} {price}/mês</strong> e acesse previsões de Astrologia, Tarot, artigos e atividades para você começar o ano preparad{pronoun}!'
    },
    
    subscribeUrl: 'assinar'
};